exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#metadata-container {\n  position: absolute;\n  bottom: 0;\n  right: 40px;\n  width: calc(70% - 40px);\n  height: 50%;\n  padding: 0px 5px 0px 5px;\n  background-color: rgba(52, 112, 101, 0.05);\n  border-top-style: solid;\n  border-top-width: 1px;\n  border-color: grey;\n}\n#observation-list {\n  position: relative;\n  height: calc(90% - 50px);\n  overflow: auto;\n  clear: left;\n}\n#observation-list .content:hover {\n  background-color: aquamarine;\n}\n.table-header {\n  float: left;\n  width: 150px;\n  margin: 5px 10px 5px 0px;\n  font-weight: bold;\n}\n.table-row {\n  height: 30px;\n  padding: 5px;\n}\n", ""]);

// exports
